import { useAppContext } from "application";
import { Link } from "components";
import { Fragment } from "react";
import { BreadcrumbProductProps } from "typing";
import { ArrowLeft, ArrowRight, Home, theme } from "ui";
import {
  BreadcrumbsContainer,
  BreadcrumbsContentMobile,
  DescriptionItem,
  DescriptionItemWrapper,
  DescriptionItemWrapperLink,
  SeparatorIcon,
} from "./styles";

const BreadcrumbProduct = (
  breadcrumbProductProps: BreadcrumbProductProps | null
) => {
  const { isClientMobile } = useAppContext();

  if (!breadcrumbProductProps?.items) {
    return null;
  }

  const {
    items: { common, mobile },
  } = breadcrumbProductProps;

  const { commonIncludesUrl, mobileIncludesUrl } = {
    commonIncludesUrl: common.filter((item) => !item?.url?.includes("null")),
    mobileIncludesUrl: !mobile?.url?.includes("null"),
  };

  return commonIncludesUrl.length > 1 || mobileIncludesUrl ? (
    <BreadcrumbsContainer>
      {isClientMobile ? (
        <BreadcrumbsContentMobile>
          <SeparatorIcon>
            <ArrowLeft
              color={theme.colors.neutral["300"]}
              width={20}
              height={20}
            />
          </SeparatorIcon>
          <Link href={mobile?.url || ""} target={mobile.target ?? "_self"}>
            <DescriptionItem>{mobile.description}</DescriptionItem>
          </Link>
        </BreadcrumbsContentMobile>
      ) : (
        <>
          <Link href="/" target="_self">
            <Home color={theme.colors.neutral["385"]} width={17} height={17} />
          </Link>
          {commonIncludesUrl?.map((item) => (
            <Fragment key={item?.url}>
              <SeparatorIcon>
                <ArrowRight
                  color={theme.colors.neutral["300"]}
                  width={20}
                  height={20}
                />
              </SeparatorIcon>
              <DescriptionItemWrapper
                as={item?.url ? Link : DescriptionItemWrapperLink}
                href={item.url}
                target={item.target ?? "_self"}
              >
                <DescriptionItem>{item.description}</DescriptionItem>
              </DescriptionItemWrapper>
            </Fragment>
          ))}
        </>
      )}
    </BreadcrumbsContainer>
  ) : null;
};

export default BreadcrumbProduct;
